import React from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Relies on AuthProvider for the initial /auth/me call. Avoids a duplicate request
 * that previously ran here whenever token was present but user state was still null.
 */
const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If no user after loading, don't render children (AuthRedirect will handle the redirect)
  if (!user) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;